// Sticky resize-handle dominance (05f) — main.js updateResizeDominance, ported from
// Bento's feature/resize-push (60802ba). Two modules side by side have overlapping handle
// zones; this keeps the module you were already on "active" (its handles + outline show,
// `resize-active`) until the pointer is clearly in another's. The pick is
// resize-rules.ts pickResizeDominant (tested); this file applies it to the page.

import { pickResizeDominant } from "./resize-rules.js";

let sticky: HTMLElement | null = null;
// Tracked on every move (even mid-drag), so a gesture's end can recompute from where the
// pointer is now.
let lastX = 0;
let lastY = 0;
let gestureOn: () => boolean = () => false;

function setResizeActive(mod: HTMLElement | null): void {
  if (mod === sticky) return;
  sticky?.classList.remove("resize-active");
  sticky = mod;
  sticky?.classList.add("resize-active");
}

function update(x: number, y: number): void {
  if (window.innerWidth <= 768) return;
  // Mid-move / resize / side-panel drag the handles stay as they were.
  if (gestureOn()) return;
  const mods = Array.from(document.querySelectorAll<HTMLElement>(".placed-module"));
  const i = pickResizeDominant(
    mods.map((m) => m.getBoundingClientRect()),
    sticky ? mods.indexOf(sticky) : -1,
    x,
    y,
  );
  setResizeActive(i < 0 ? null : mods[i]!);
}

/** Recompute from the last pointer position — call at the very end of a gesture, so the
 *  right module's handles show without waiting for the next mouse move. */
export function refreshResizeDominance(): void {
  update(lastX, lastY);
}

/**
 * Start tracking the pointer. Installed right AFTER main.js loads, where main.js
 * registered these listeners: their pointerup must run after main.js's side-panel drop
 * has ended (else it'd still see the drag on and skip). The move and resize are added
 * on each press — later still — so they call refreshResizeDominance() themselves.
 */
export function installResizeDominance(isGestureOn: () => boolean): void {
  gestureOn = isGestureOn;
  document.addEventListener("pointermove", (e) => {
    lastX = e.clientX;
    lastY = e.clientY;
    update(e.clientX, e.clientY);
  });
  document.addEventListener("pointerup", refreshResizeDominance);
}
